// extracted by mini-css-extract-plugin
export default {"rootContainer":"MainContainer_rootContainer__ifUxP","navBar":"MainContainer_navBar__QD6Xz"};